export default {
  "fr": {
    "navbar": {
      "customer": {
        "after_care": "Aftercare",
        "dashboard": "Accueil",
        "decisions": "Décisions",
        "documents": "Documents",
        "inspirations": "Inspirations",
        "installments": "Finances",
        "profile": "Votre Profil",
        "projectinfo": "Information",
        "question_lists": "FAQ",
        "surveys": "Enquêtes",
        "ticket": {
          "new": "Nouvelle Conversation"
        },
        "tickets": "Conversations",
        "units": "Dossier d'intervention ultérieure"
      },
      "employee": {
        "client": "Profil {client}",
        "contacts": "Contacts",
        "customer": "Client",
        "dashboard": "Accueil",
        "employee": "Collègue",
        "partner": "Partenaire",
        "profile": "Votre Profil",
        "project": {
          "after_care": "Aftercare",
          "decisions": "Décisions",
          "documents": "Documents",
          "email_conversations": "E-mails entrants",
          "info": "Information",
          "installments": "Finances",
          "news": "Actualités",
          "question_lists": "FAQs",
          "sales": "Vente (bêta)",
          "surveys": "Enquêtes",
          "todos": "Tâches"
        },
        "projects": "Projets",
        "ticket": {
          "new": "Nouvelle Conversation"
        },
        "tickets": "Conversations"
      },
      "partner": {
        "contacts": "Contacts",
        "dashboard": "Accueil",
        "profile": "Votre profile",
        "project": {
          "after_care": "Aftercare",
          "decisions": "Décisions",
          "documents": "Documents",
          "tickets": "Conversations"
        },
        "projects": "Projets"
      },
      "supervisor": {
        "audit": "Audit",
        "clients": "Clients",
        "dashboard": "Dashboard",
        "emails": "Emails",
        "metrics": "Metrics",
        "users": "Users"
      },
      "topnavbar": {
        "company": "Société",
        "helpcenter": "Centre d'Aide",
        "logout": "Déconnexion",
        "profile": "Profil",
        "selectTeam": "Sélectionner entreprise",
        "team": "Équipe"
      }
    }
  }
}